"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = applyPackagesCache;

function applyPackagesCache(_ref) {
  var proj = _ref.proj,
      paths = _ref.paths,
      manifest = _ref.manifest,
      version = _ref.version,
      scriptsDomainUrl = _ref.scriptsDomainUrl;

  var validForCache = function validForCache(pkg) {
    return paths[pkg] && manifest[pkg] !== version;
  };

  var overrideFromCache = function overrideFromCache(pkg) {
    paths[pkg] = "".concat(scriptsDomainUrl, "services/").concat(proj, "/").concat(manifest[pkg], "/").concat(paths[pkg]);
  };

  Object.keys(manifest).filter(validForCache).forEach(overrideFromCache);
}
//# sourceMappingURL=applyPackagesCache.js.map